import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-344b51aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "suggestion__title" }, "Dê sua sugestão para melhorias!", -1))
const _hoisted_2 = { class: "description__area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_TextareaInput = _resolveComponent("TextareaInput")!
  const _component_SendButton = _resolveComponent("SendButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "is-open": _ctx.isOpen,
    onToggle: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggle'))),
    width: "700px",
    height: "auto"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TextInput, {
          id: "title",
          label: "Título",
          title: "Título",
          "max-length": 100,
          modelValue: _ctx.title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
          required: "",
          hasCharacterCounter: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_TextareaInput, {
          id: "doubt",
          label: "Descrição",
          modelValue: _ctx.description,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
          required: "",
          maxLength: 500,
          hasCharacterCounter: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_SendButton, {
          title: "Enviar sugestão",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSubmit()))
        })
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}